/**
 * @file 接口
 */
import axios from 'axios';
// 请求的默认域名
// axios.defaults.baseURL = 'apiURL';
// 添加一个请求拦截器
axios.interceptors.request.use(config => {
    // 可加一些公共的头部
    // config.headers.languagetype = 'CN';
    return config;
}, err => {
    return Promise.reject(err);
});
//添加一个响应拦截器
axios.interceptors.response.use(res => {
    //在这里对返回的数据进行处理
    if (res.data.code === 1000) {
        return Promise.reject({
            ...res.data,
            isLogin: false
        }); // 请登录
    }
    if (res.data.code !== 0) {
        window.vue.$root.$emit('showToast', res.data.msg);
        return Promise.reject(res.data);
    }
    return res.data;
}, err => {
    window.vue.$root.$emit('showToast', '网络不给力，请重试');
    return Promise.reject(err);
});


export default axios;



// WEBPACK FOOTER //
// ./src/api.js